// Suggested soft skills shown in the Autocomplete, per CV language. The field is freeSolo,
// so these are only suggestions — applicants can still type their own.
export const SOFT_SKILLS_OPTIONS: Record<'de' | 'en', string[]> = {
  de: [
    'kontaktfreudig',
    'zuverlässig',
    'begeistert',
    'engagiert',
    'proaktiv',
    'energiegeladen',
    'verantwortungsbewusst',
    'kommunikativ',
    'überzeugend',
    'teamfähig',
    'problemlösend',
    'analytisch',
    'kritisch denkend'
  ],
  en: [
    'outgoing',
    'reliable',
    'enthusiastic',
    'committed',
    'proactive',
    'energetic',
    'responsible',
    'communicative',
    'persuasive',
    'team player',
    'problem solver',
    'analytical',
    'critical thinker'
  ]
};

/**
 * Pick the suggestion list for the CV's language. `language` is a locale string
 * (e.g. `de-DE`, `en-US`), so we match on the `de` prefix and default to English.
 */
export const getSoftSkillOptions = (language?: string): string[] =>
  (language ?? '').toLowerCase().startsWith('de')
    ? SOFT_SKILLS_OPTIONS.de
    : SOFT_SKILLS_OPTIONS.en;
